const state = () => ({
  watchlist: null,
  bookmarks: null,
  dataUser: null,
  notes: null,
  reports: null,
  userAccess: [],
  userSubscription: null,
  daysSince: null,
});

const getters = {
  getId: (state) => {
    if (state.dataUser && state.dataUser.salesforceId) {
      return state.dataUser.salesforceId;
    }
  },
  getUser: (state) => {
    if (state.dataUser) {
      return state.dataUser;
    }
  },
  getCompany: (state) => {
    let companies = "";
    if (
      state.dataUser &&
      state.dataUser.include &&
      state.dataUser.include.field_company
    ) {
      for (const key in state.dataUser.include.field_company) {
        if (
          state.dataUser.include.field_company[key].name &&
          state.dataUser.include.field_company[key].name.length
        ) {
          companies =
            companies +
            state.dataUser.include.field_company[key].name[0].value +
            ",";
        }
      }
    }
    return companies.slice(0, -1);
  },
  getOrderNotes: (state) => {
    const arr = [];
    if (state.notes && state.notes.length) {
      arr.push({
        id: state.notes[0].page_id,
        name: state.notes[0].page,
        notes: state.notes[0].section,
      });
      state.notes.forEach((el) => {
        const item = arr.find((el2) => el2.id === el.page_id);
        if (item) {
          item.notes.concat(el.section);
        } else {
          arr.push({ id: el.page_id, name: el.page, notes: el.section });
        }
      });
    }
    return arr;
  },
  getOrderedList: (state) => {
    const keys = [];

    for (const key in state.watchlist) {
      keys.push(state.watchlist[key]);
    }

    return keys.reverse();
  },
  getWatchedSections: (state) => {
    const arr = [];
    if (state.dataUser) {
      if (
        state.dataUser.field_jurisdiction &&
        state.dataUser.field_jurisdiction.length
      ) {
        state.dataUser.field_jurisdiction.forEach((el) =>
          arr.push(el.target_id)
        );
      }
      if (state.dataUser.field_sector && state.dataUser.field_sector.length) {
        state.dataUser.field_sector.forEach((el) => arr.push(el.target_id));
      }
      if (
        state.dataUser.field_specialism &&
        state.dataUser.field_specialism.length
      ) {
        state.dataUser.field_specialism.forEach((el) => arr.push(el.target_id));
      }
    }

    return arr;
  },
  getBookmarks: (state) => {
    const objCopy = Object.assign([], state.bookmarks);

    return objCopy.sort((a, b) => (a.created_date > b.created_date ? -1 : 1));
  }
};

const mutations = {
  setData(state, data) {
    state[data.label] = data.data;
  },
};

const actions = {
  async getData({ commit, state }, { url }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
        console.error(response.status, url);
      });
  },

  // async subscription({commit, state}, {url, arr}) {
  //     const body = {
  //         method: "PATCH",
  //         url: `${this.$config.jsonApiURL}${url}`,
  //         data: {field_email_subscription_type: arr}
  //     }
  //     return await this.$axios(body)
  //         .then(data => console.log(url))
  // }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
